<template>
  <div id="June2024" class="202404 relative">
    <div class="fixed z-50 hidden xl:block menu" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="block px-3 -mb-8">
        <img src="~@/assets/images/202406/menu/girl1.png" class="object-contain mx-auto">
      </a>
      <div class="rounded-t-full rounded-b-full border-4 overflow-hidden" style="border-color: #D9D9D9;">
        <div class="menu_item block px-3 py-5 pt-12 bg-white border-b-2 border-dashed">
          <img src="~@/assets/images/202406/menu/menu_01.png" class="object-contain mx-auto">
        </div>
        <a class="menu_item cursor-pointer block px-3 py-5 bg-white border-b-2 border-dashed relative" @click="toTop('#plan1')"  style="border-color: #D9D9D9;">
          <img src="~@/assets/images/202406/menu/menu_02.png" class="object-contain mx-auto">
          <div class="absolute hat"><img src="~@/assets/images/202406/menu/hat.png" class="object-contain block mx-auto"></div>
        </a>
        <a class="menu_item cursor-pointer block px-3 py-5 bg-white border-b-2 border-dashed relative" @click="toTop('#plan2')"  style="border-color: #D9D9D9;">
          <img src="~@/assets/images/202406/menu/menu_03.png" class="object-contain mx-auto">
          <div class="absolute hat"><img src="~@/assets/images/202406/menu/hat.png" class="object-contain block mx-auto"></div>
        </a>
        <a class="menu_item cursor-pointer block px-3 py-5 bg-white border-b-2 border-dashed relative" @click="toTop('#plan3')"  style="border-color: #D9D9D9;">
          <img src="~@/assets/images/202406/menu/menu_04.png" class="object-contain mx-auto">
          <div class="absolute hat"><img src="~@/assets/images/202406/menu/hat.png" class="object-contain block mx-auto"></div>
        </a>
        <a class="menu_item cursor-pointer block px-3 py-5 pb-12 bg-white rounded-b-full relative" @click="toTop('#plan4')"  style="border-color: #D9D9D9;">
          <img src="~@/assets/images/202406/menu/menu_05.png" class="object-contain mx-auto ">
          <div class="absolute hat"><img src="~@/assets/images/202406/menu/hat.png" class="object-contain block mx-auto"></div>
        </a>
      </div>

    </div>

    <div class="banner w-full px-6 md:px-2">
      <div class="max-w-6xl mx-auto">
        <div class="pt-10 md:pt-16"><img src="~@/assets/images/202406/banner.png" class="object-contain block mx-auto"></div>
      </div>
    </div>

    <section class="main mx-auto">
      <div class="slogan01 pt-8 pb-12 md:pb-24 px-6 md:px-2">
        <div class="max-w-6xl mx-auto">
          <div class=""><img src="~@/assets/images/202406/slogan01.png" class="object-contain block mx-auto"></div>
        </div>
      </div>

      <div class="slogan02 px-2">
        <div class="max-w-6xl mx-auto flex justify-center">
          <div class="w-3/12 md:hidden"></div>
          <div class="w-6/12 md:w-full flex flex-wrap items-center justify-center -mt-4 md:mt-0">
            <div class="hover-item md:-mt-12 px-2 w-1/2 md:w-1/4 cursor-pointer" @click="toTop('#plan1')">
              <img src="~@/assets/images/202406/p1.png" class="off object-contain mx-auto -ml-1 md:ml-0">
              <img src="~@/assets/images/202406/button-p1=hover.png" class="on object-contain mx-auto -ml-1 md:ml-0">
            </div>
            <div class="hover-item md:-mt-12 px-2 w-1/2 md:w-1/4 cursor-pointer" @click="toTop('#plan2')">
              <img src="~@/assets/images/202406/p2.png" class="off object-contain mx-auto">
              <img src="~@/assets/images/202406/button-p2=hover.png" class="on object-contain mx-auto">
            </div>
            <div class="hover-item md:-mt-12 px-2 w-1/2 md:w-1/4 cursor-pointer" @click="toTop('#plan3')">
              <img src="~@/assets/images/202406/p3.png" class="off object-contain mx-auto">
              <img src="~@/assets/images/202406/button-p3=hover.png" class="on object-contain mx-auto">
            </div>
            <div class="hover-item md:-mt-12 px-2 w-1/2 md:w-1/4 cursor-pointer" @click="toTop('#plan4')">
              <img src="~@/assets/images/202406/p4.png" class="off object-contain mx-auto">
              <img src="~@/assets/images/202406/button-p4=hover.png" class="on object-contain mx-auto">
            </div>
          </div>
          <div class="w-3/12 flex items-end md:hidden -mb-4">
            <img src="~@/assets/images/202406/plan01_girl02.png" class="object-contain block mx-auto">
          </div>
        </div>

          <!-- <div class=""><img src="~@/assets/images/202406/plan01_girl02.png" class="object-contain block mx-auto"></div> -->
      </div>

      <div id="plan1" class="plan1 py-4 md:py-8 px-4 md:px-2">
        <div class="plan1_inner max-w-6xl mx-auto bg-white rounded-xl pt-6 md:pt-12 px-5 md:px-12 pb-2 shadow-xl">
          <a target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=372" class="flex justify-center mx-auto">
            <div class="md:px-4 border-b-2 md:pb-6 border-dashed w-1/3 md:w-auto">
              <img src="~@/assets/images/202406/ABC.png" class="object-contain block mx-auto">
            </div>
            <div class="px-4 border-b-2 pb-6 border-dashed w-2/3 md:w-auto pr-10 md:pr-4">
              <div class="flex-col md:flex-row md:items-end mb-4 md:mb-12 md:pt-2 flex">
                <div class=""><img src="~@/assets/images/202406/plan01_text.png" class="object-contain block"></div>
                <div class="hover-item w-1/2 md:w-auto">
                  <img src="~@/assets/images/202406/sub_btn.png" class="off object-contain">
                  <img src="~@/assets/images/202406/sub_btn_hover.png" class="on object-contain">
                </div>
              </div>
              <div class="mt-4"><img src="~@/assets/images/202406/plan01_text02.png" class="object-contain block"></div>
            </div>
            <div class="px-4 hidden md:flex items-end -mb-6 "><img src="~@/assets/images/202406/plan01_girl.png" class="object-contain"></div>
          </a>

          <a target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=372" class="flex flex-wrap justify-center">
            <div class="w-1/4 p-1 md:p-2 flex flex-col justify-center items-center">
              <div class="mb-2"><img src="~@/assets/images/202406/live.png" class="object-contain"></div>
              <div><img src="~@/assets/images/202406/live_text.png" class="object-contain"></div>
            </div>
            <div class="w-1/4 p-1 md:p-2 flex flex-col justify-center items-center">
              <div class="mb-2"><img src="~@/assets/images/202406/all.png" class="object-contain"></div>
              <div><img src="~@/assets/images/202406/all_text.png" class="object-contain"></div>
            </div>
            <div class="w-1/4 p-1 md:p-2 flex flex-col justify-center items-center">
              <div class="mb-2"><img src="~@/assets/images/202406/cnn.png" class="object-contain"></div>
              <div><img src="~@/assets/images/202406/cnn_text.png" class="object-contain"></div>
            </div>
            <div class="w-1/4 p-1 md:p-2 flex flex-col justify-center items-center">
              <div class="mb-2"><img src="~@/assets/images/202406/jp.png" class="object-contain"></div>
              <div><img src="~@/assets/images/202406/jp_text.png" class="object-contain"></div>
            </div>
          </a>

          <a class="sub_flag flex justify-between items-center py-6 md:py-10" target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=372">
            <div class="w-2 h-2 md:w-3 md:h-3 bg-black rounded-full"></div>
            <div class="sub_flag_img z-10 hover-item w-5/12">
              <img src="~@/assets/images/202406/more_meg.png" class="off object-contain">
              <img src="~@/assets/images/202406/more_meg_hover.png" class="on object-contain">
            </div>
            <div class="w-2 h-2 md:w-3 md:h-3 bg-black rounded-full"></div>
          </a>

          <a target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=373" class="flex justify-center mx-auto relative">
            <div class="px-2 md:px-4 border-b-2 pb-4 md:pb-8 border-dashed flex items-end w-5/12 md:w-auto">
              <img src="~@/assets/images/202406/hiw.png" class="object-contain block mx-auto">
            </div>
            <a class="md:px-4 border-b-2 pb-4 md:pb-8 border-dashed flex md:items-center w-7/12 md:w-auto" target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=380">
              <img src="~@/assets/images/202406/plan01_text0202.png" class="object-contain  mx-auto hidden md:block">
              <img src="~@/assets/images/202406/plan01_text0202_m.png" class="object-contain md:hidden">
            </a>
            <div class="px-4 hidden md:flex"><img src="~@/assets/images/202406/plan01_girl02.png" class="object-contain"></div>
            <div class="px-4 md:hidden absolute w-5/12 woman"><img src="~@/assets/images/202406/plan01_girl.png" class="object-contain"></div>
          </a>

          <a target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=380" class="flex flex-wrap justify-center">
            <div class="w-1/4 md:p-2"><img src="~@/assets/images/202406/hiw_img01.png" class="object-contain"></div>
            <div class="w-1/4 md:p-2"><img src="~@/assets/images/202406/hiw_img02.png" class="object-contain"></div>
            <div class="w-1/4 md:p-2"><img src="~@/assets/images/202406/hiw_img03.png" class="object-contain"></div>
            <div class="w-1/4 md:p-2"><img src="~@/assets/images/202406/hiw_img04.png" class="object-contain"></div>
          </a>
        </div>
      </div>

      <div id="plan2" class="plan2 py-4 md:py-8 px-4 md:px-2">
        <div class="plan2_inner max-w-6xl mx-auto bg-white rounded-xl py-4 md:py-12 shadow-lg">
          <div class="flex justify-center flex-wrap md:flex-no-wrap relative">
            <div class="order-1 px-2 w-5/12 md:w-auto absolute z-10 md:static woman2 flex items-end" style="" ><img src="~@/assets/images/202406/plan02_girl.png" class="object-contain block mx-auto md:-ml-8"></div>

            <div class="order-3 md:order-2 px-12 md:px-4 w-full md:w-auto mt-4 md:mt-0">
              <div class="mb-2 md:mb-4"><img src="~@/assets/images/202406/plan02_text01.png" class="object-contain block"></div>
              <div class="mb-6 md:mb-8"><img src="~@/assets/images/202406/plan02_text02.png" class="object-contain block"></div>
              <div class="mb-2 md:mb-8"><img src="~@/assets/images/202406/plan02_text03.png" class="object-contain block"></div>
              <div class="mb-4 md:mb-8"><img src="~@/assets/images/202406/plan02_text04.png" class="object-contain block"></div>
              <div class="flex mb-4">
                <a target="_blank" href="https://store.liveabc.com/recent/detail/6743" class="mr-4 hover-item">
                  <img src="~@/assets/images/202406/more_btn.png" class="off object-contain mx-auto">
                  <img src="~@/assets/images/202406/more_btn_hover.png" class="on object-contain mx-auto">
                </a>
                <a target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=374" class="hover-item">
                  <img src="~@/assets/images/202406/shop_lp.png" class="off object-contain mx-auto">
                  <img src="~@/assets/images/202406/shop_lp_hover.png" class="on object-contain mx-auto">
                </a>
              </div>
            </div>
            <div class="order-2 md:order-3 live_pen px-20 md:px-0">
              <div class=""><img src="~@/assets/images/202406/live_pen.png" class="object-contain block mx-auto"></div>
            </div>
          </div>
        </div>
      </div>

      <div id="plan3" class="plan3 px-2">
        <div class="plan3_inner max-w-6xl mx-auto md:py-6">
          <a target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=375" class="flex justify-center">
            <div class=""><img src="~@/assets/images/202406/plan3_text.png" class="object-contain block mx-auto"></div>
            <div class=""><img src="~@/assets/images/202406/plan3_girl.png" class="object-contain block mx-auto"></div>
          </a>
          <div class="flex flex-wrap px-2 md:px-4 justify-center">
            <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" v-for="(item, index) in bookData" :key="index" class="w-1/3 md:w-1/4 p-1 md:p-2">
              <img :src="item.img_url" class="object-contain block mx-auto">
            </router-link>
          </div>
        </div>
      </div>

      <div id="plan4" class="plan4 py-4 md:py-8 px-4 md:px-2">
        <div class="plan4_inner max-w-6xl mx-auto">
          <a target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=379" class="flex justify-center mb-3">
            <div class=""><img src="~@/assets/images/202406/plan4_girl.png" class="object-contain block mx-auto"></div>
            <div>
              <div class="mb-4"><img src="~@/assets/images/202406/plan04_pop.png" class="object-contain block mx-auto"></div>
              <div class=""><img src="~@/assets/images/202406/plan04_text.png" class="object-contain block mx-auto"></div>
            </div>
          </a>
          <div class="flex flex-wrap px-2 md:px-4 justify-center">
            <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" v-for="(item, index) in bookData2" :key="index" class="w-1/3 md:w-1/4 p-2">
              <img :src="item.img_url" class="object-contain block mx-auto">
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="footer py-12 bg-black">

      <p class="md:text-xl text-white text-center tracking-wider mb-10">活動內容以LiveABC官網發布為主。<span class="md:hidden"><br/></span>本公司保留活動修改、變更之權利。</p>

      <router-link :to="{ name: 'index' }" class="hover-item">
        <img src="~@/assets/images/202406/back_btn.png" class="off object-contain mx-auto w-6/12 md:w-auto">
        <img src="~@/assets/images/202406/back_btn_hover.png" class="on object-contain mx-auto w-6/12 md:w-auto">
      </router-link>
    </section>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'June2024',
  metaInfo () {
    return {
      title: '訂雜誌送美食券！LiveABC畢業季書展限時69折',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      planData: [
        { id: 7725, type: 'abc', introduction: '初級/基礎/活用', text: '打好英語基礎的最佳選擇！', class: 'w-full', img_url: require('@/assets/images/202405/m/ABC-COVER.png') },
        { id: 7726, type: 'live', introduction: '中級/生活/實用', text: '日常生活實用英語輕鬆學！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/LIVE-COVER.png') },
        { id: 7727, type: 'all', introduction: '中高級/進階/應用', text: '閱讀寫作訓練豐富又多元！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/ALL-COVER.png') },
        { id: 7728, type: 'cnn', introduction: '新聞/時事/新知', text: '托福、多益檢測超必備！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/CNN-COVER.png') },
        { id: 7729, type: 'jp', introduction: '初級/生活/實用', text: '自學日語最佳輔助教材！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/JP-COVER.png') },
        { id: 7724, type: 'hiw', introduction: '圖解/百科/符合108課綱', text: '團購秒殺搶購，佳評如潮！', class: 'w-full', img_url: require('@/assets/images/202405/m/HIW-COVER.png') }
      ],
      bookData: [
        { id: 8537, img_url: require('@/assets/images/202406/plan3_book01.png') },
        { id: 8214, img_url: require('@/assets/images/202406/plan3_book02.png') },
        { id: 8150, img_url: require('@/assets/images/202406/plan3_book03.png') },
        { id: 8158, img_url: require('@/assets/images/202406/plan3_book04.png') },
        { id: 8009, img_url: require('@/assets/images/202406/plan3_book05.png') },
        { id: 7955, img_url: require('@/assets/images/202406/plan3_book06.png') },
        { id: 7849, img_url: require('@/assets/images/202406/plan3_book07.png') },
        { id: 7647, img_url: require('@/assets/images/202406/plan3_book08.png') },
        { id: 7560, img_url: require('@/assets/images/202406/plan3_book09.png') },
        { id: 8974, img_url: require('@/assets/images/202406/plan3_book10.png') },
        { id: 7093, img_url: require('@/assets/images/202406/plan3_book11.png') },
        { id: 9237, img_url: require('@/assets/images/202406/plan3_book12.png') }
      ],
      bookData2: [
        { id: 8744, img_url: require('@/assets/images/202406/plan4_book01.png') },
        { id: 8743, img_url: require('@/assets/images/202406/plan4_book02.png') },
        { id: 8630, img_url: require('@/assets/images/202406/plan4_book03.png') },
        { id: 8629, img_url: require('@/assets/images/202406/plan4_book04.png') },
        { id: 8473, img_url: require('@/assets/images/202406/plan4_book05.png') },
        { id: 8023, img_url: require('@/assets/images/202406/plan4_book06.png') },
        { id: 7436, img_url: require('@/assets/images/202406/plan4_book07.png') },
        { id: 7444, img_url: require('@/assets/images/202406/plan4_book08.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#June2024 {
  .menu {
    .menu_item {
      .hat {
        display: none;
        right: -5%;
        top: -25%;
      }
      &:hover {
        .hat {
          display: block;
        }
      }
    }
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .banner {
    // background-color: #FDE7EC;
    background-image: url('~@/assets/images/202406/banner_bg.png');
    // background-repeat: no-repeat;
    // background-size: cover;
    // background-position: center bottom;
    // @media (max-width: 768px) {
    //   background-image: url('~@/assets/images/202405/m/BG.png');
    //   background-size: cover;
    // }
  }
  .slogan01 {
    background-color: #EFEFEF;
  }
  .slogan02 {
    background-color: #4C84D6;
  }
  .plan1 {
    background-color: #4C84D6;
    .plan1_inner {
      background-image: url('~@/assets/images/202406/plan01_flag.png');
      background-position: right top;
      background-repeat: no-repeat;
      @media (max-width: 768px) {
        background-size: 30%;
      }
      .sub_flag {
        // .sub_flag_img {
          position: relative;
          &:after {
            position: absolute;
            content: "";
            height: 2px;
            width: 100%;
            top: 50%;
            left: 0;
            display: block;
            background-color: black;
            z-index: 0;
          }
        // }
      }
      .woman {
        right: -15%;
        bottom: -10%;
      }
    }

  }
  .plan2 {
    background-color: #EFEFEF;
    .plan2_inner {
      background-image: url('~@/assets/images/202406/plan02_flag.png');
      background-position: left top;
      background-repeat: no-repeat;
      @media (max-width: 768px) {
        background-size: 30%;
      }
      .live_pen {
      }
      .woman2 {
        left: -10%;
        top: 20%;
        @media (max-width: 768px) {
          left: -10%;
          top: 20%;
        }
      }
    }
  }
  .plan3 {
    background-image: url('~@/assets/images/202406/banner_bg.png');
  }
  .plan4 {
    background-color: #EFEFEF;
  }
  .plan5 {
  }
  .footer {
  }
}
</style>
